// NPM Imports
import React, { Component } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Component Imports
import ComponentBlocks from "./ComponentBlocks";

// Internal Imports
import {
  emptyTable,
  emptyEditor,
  emptyImage,
  emptySignatureSpace,
  emptyQuoteTablePlaceholder,
  lineSpace,
  pageBreak,
  googleSheetSpace,
  emptyPaymentButton,
} from "../../../utils/documentUtils";
import { readDataFromLocalStorage } from "../../../utils/globalUtils";

import { DOCUMENTS, BILLING } from "../../../constants";

// Destructuring
const {
  DOCUMENT_COMPONENT_TYPES,
  SECTION_AND_POSITION_WISE_DOCUMENT_BLOCKS,
} = DOCUMENTS;
const { EXCLUDE_QUOTE_TABLE_PLANS } = BILLING;

class PlusButtonAddComponentsV2 extends Component {
  addComponentBtnsRef = React.createRef();

  _updateBtnState = flag => {
    this.props.updateAddBtnsState(flag);
  };

  // Get the new section by type
  _getNewSectionByType = sectionType => {
    let section = null;
    const { sectionList } = this.props;
    switch (sectionType) {
      case "add-table":
        section = emptyTable(
          this.props.mode,
          sectionList.filter(sec => sec.type === DOCUMENT_COMPONENT_TYPES.TABLE)
            .length,
        );
        break;
      case "add-text":
        section = emptyEditor(this.props.mode);
        break;
      case "add-dealtable":
        section = emptyQuoteTablePlaceholder();
        break;
      case "add-image":
        section = emptyImage(
          sectionList.filter(sec => sec.type === DOCUMENT_COMPONENT_TYPES.IMAGE)
            .length,
        );
        break;
      case "add-quotetable-placeholder":
        section = emptyQuoteTablePlaceholder();
        break;
      case "add-page-break":
        section = pageBreak();
        break;
      case "add-line-space":
        section = lineSpace();
        break;
      case "add-signature-space":
        section = emptySignatureSpace(
          sectionList.filter(
            sec =>
              sec.type === DOCUMENT_COMPONENT_TYPES.EMPTY_SIGNATURE_CONTAINER,
          ).length,
        );
        break;
      case "add-google-sheet":
        section = googleSheetSpace(
          sectionList.filter(
            sec => sec.type === DOCUMENT_COMPONENT_TYPES.GOOGLE_SHEET,
          ).length,
        );
        break;
      case "add-payment-button":
        section = emptyPaymentButton();
        break;
      default:
        break;
    }
    return section;
  };

  _getDocumentBlocks = userSignUpInfo => {
    const { mode, itemType, sectionList, showDocumentDiffView } = this.props;
    // Get the Add document component Button's array
    const btnComponents = DOCUMENTS.ADD_COMPONENTS[mode];
    let buttons = DOCUMENTS.BUTTONS.filter(button =>
      btnComponents.includes(button.id),
    );

    // Filter the buttons based on "Billing Plan"
    if (
      userSignUpInfo &&
      EXCLUDE_QUOTE_TABLE_PLANS.indexOf(userSignUpInfo.billing_plan) > -1
    ) {
      buttons = buttons.filter(
        btn =>
          !(
            btn.id === "add-dealtable" ||
            btn.id === "add-quotetable-placeholder"
          ),
      );
    }

    let filterBtns = buttons;
    if (
      itemType === "CoverPage" ||
      itemType === "header" ||
      itemType === "footer"
    ) {
      filterBtns = buttons.filter(
        btn =>
          btn.id !== "add-dealtable" &&
          btn.id !== "add-quotetable-placeholder" &&
          btn.id !== "add-page-break" &&
          btn.id !== "add-signature-space" &&
          btn.id !== "add-google-sheet" &&
          btn.id !== "add-payment-button",
      );
    }
    // Get the blocks according to the position(Top, Right, Bottom or Left)
    filterBtns = filterBtns.filter(btn =>
      SECTION_AND_POSITION_WISE_DOCUMENT_BLOCKS[btn.id][
        this.props.blockType
      ].includes(this.props.position),
    );

    // Get the Add document component Buttons element
    const components = filterBtns.map(component => {
      let isDisabled = false;
      if (component.id === "add-dealtable") {
        isDisabled =
          sectionList.findIndex(
            section =>
              section.type === DOCUMENT_COMPONENT_TYPES.DEAL_TABLE ||
              section.type === DOCUMENT_COMPONENT_TYPES.QUOTE_TABLE ||
              section.type === DOCUMENT_COMPONENT_TYPES.QUOTE_TABLE_WRAPPER,
          ) > -1;
      } else if (component.id === "add-quotetable-placeholder") {
        isDisabled =
          sectionList.findIndex(
            section =>
              section.type === DOCUMENT_COMPONENT_TYPES.QUOTE_TABLE_WRAPPER,
          ) > -1;
      }
      isDisabled = isDisabled || showDocumentDiffView;
      component.isDisabled = isDisabled;
      return component;
    });
    return components;
  };

  _addComponent = (event, id) => {
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();
    const newSection = this._getNewSectionByType(id);
    if (newSection) {
      this.props.addComponent(newSection);
      // Close Add components button popup
      this.props.updateAddComponentBtnsState(null, false);
      document.removeEventListener(
        "click",
        this._handleAddComponentBtnsOutsideClick,
        true,
      );
    }
  };

  _toggleAddComponentBtnsHandler = (event, position) => {
    const { clickedPlusBtnSectionId, rowColumnId } = this.props;
    if (event) {
      if (clickedPlusBtnSectionId === rowColumnId) {
        event.preventDefault();
        event.nativeEvent.stopImmediatePropagation();
      }
    }
    // attach/remove event handler
    if (!this.props.showAddComponentBtns) {
      document.addEventListener(
        "click",
        this._handleAddComponentBtnsOutsideClick,
        true,
      );
    } else {
      document.removeEventListener(
        "click",
        this._handleAddComponentBtnsOutsideClick,
        true,
      );
    }
    this.props.updateAddComponentBtnsState(position, rowColumnId);
  };

  _handleAddComponentBtnsOutsideClick = e => {
    const node = this.addComponentBtnsRef.current;
    if (node && node.contains(e.target)) {
      return;
    }
    this._toggleAddComponentBtnsHandler();
  };

  render() {
    const userSignUpInfo = readDataFromLocalStorage("userSignUpInfo");
    const {
      showAddComponentBtns,
      position,
      clickedPlusBtnSectionId,
      clickedPlusBtnPosition,
      rowColumnId,
      hoverPlusBtn,
    } = this.props;

    let showPopup = false;
    if (
      showAddComponentBtns &&
      clickedPlusBtnSectionId === rowColumnId &&
      clickedPlusBtnPosition === position
    ) {
      showPopup = true;
    }

    let className = `plusbuttonaddcomponentsv2-container ${
      this.props.className
    } `;
    if (position === "top" || position === "bottom") {
      className += ` top-bottom-position ${position} `;
    } else if (position === "left" || position === "right") {
      className += " left-right-position  ";

      if (position === "left" && this.props.isFirstBlock) {
        className += " first-left-right ";
      }
      if (position === "right" && this.props.isLastBlock) {
        className += " last-left-right ";
      }

      className += ` ${position} `;
    }
    if (showPopup) {
      className += " active ";
    }
    if (
      showAddComponentBtns &&
      (clickedPlusBtnSectionId !== rowColumnId ||
        clickedPlusBtnPosition !== position)
    ) {
      className += " deactive ";
    }
    if (
      (hoverPlusBtn !== "ALL" && hoverPlusBtn !== position) ||
      this.props.isTableOptionsDDOpen
    ) {
      className += " deactive ";
    }
    return (
      <div
        ref={this.addComponentBtnsRef}
        className={className}
        onMouseOver={event => this.props.handlePlusBtnHover(event, position)}
        onFocus={() => {}}
        onMouseOut={event => this.props.handlePlusBtnHover(event, "ALL")}
        onBlur={() => {}}>
        {/* -------- Plus Button Icon and Line Section -------- */}
        <div className="plusbuttonaddcomponentsv2-indicator">
          <div className="plusbuttonaddcomponentsv2-line" />
          <span
            data-test="add-components-v2-plus-button"
            className="plusbuttonaddcomponentsv2-plus-button-icon"
            onClick={event =>
              this._toggleAddComponentBtnsHandler(event, position)
            }
            onKeyPress={() => {}}
            role="button"
            tabIndex="0">
            <FontAwesomeIcon icon={["far", "plus"]} />
          </span>
        </div>

        {/* -------- Component Blocks Container Section -------- */}
        {showPopup && (
          <div className="plusbuttonaddcomponentsv2-blocks-container">
            <div className="plusbuttonaddcomponentsv2-blocks-wrapper">
              <span className="add-component-arrow" />
              <div
                className="plusbuttonaddcomponentsv2-component-blocks"
                data-test="addcomponents-add-component-items">
                <div className="plusbuttonaddcomponentsv2-block-heading">
                  Add Block
                </div>
                <ComponentBlocks
                  customClassName={`plusbuttonaddcomponentsv2-blocks position-${position}`}
                  blocks={this._getDocumentBlocks(userSignUpInfo)}
                  isClickable
                  handleOnClick={this._addComponent}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const { components } = props;
  const sectionList = [];
  Object.keys(components).forEach(componentId => {
    if (components[componentId] && components[componentId].content) {
      sectionList.push({
        id: componentId,
        type: components[componentId].content.type,
      });
    }
  });

  return {
    sectionList,
  };
};

export default connect(mapStateToProps)(PlusButtonAddComponentsV2);



// WEBPACK FOOTER //
// ./src/components/DocumentComponents/PlusButtonAddComponentsV2/index.js